import Highcharts from 'highcharts';
import {format} from '../../filters/format';
import countriesEN from '../../configs/localization/countriesEN';
import Rx from 'rx';
import {ckmeans} from 'simple-statistics';

let worldMapKeys = _.keys(countriesEN);

export function setColorScale(countriesData, scale=10) {
  let values = _.chain(countriesData).map('players').sort().value();
  let ranges = ckmeans(values, scale).map((range) => [_.min(range), _.max(range)]);

  return countriesData.map((countryData) => {
    let rangeIndex = _.findIndex(ranges, ([min,max]) => {
      return countryData.players >= min && countryData.players <= max;
    });
    countryData.colorScale = Number(((1 + rangeIndex) / scale).toFixed(2));
    return countryData;
  });
}

let mapConfig = {
  chart: {
    backgroundColor: '',
    spacingTop: 40,
    spacingRight: 20,
    spacingBottom: 20,
    spacingLeft: 20,
    alignTicks: false,
    style: {
      font: '12px "proxima-nova", sans-serif'
    }
  },
  legend: {
    enabled: false
  },
  colorAxis: {
    min: 2000,
    max: 100000,
    dataClassColor: 'category'
  },
  mapNavigation: {
    enabled: true,
    enableMouseWheelZoom: false,
    buttonOptions: {
      style: {
        color: '#a3a3a3'
      },
      theme: {
        fill: '#fcfcfc',
        'stroke-width': 1,
        stroke: '#e7e7e7',
        r: 3,
        states: {
          hover: {
            stroke: '#d2d2d2',
            fill: '#fcfcfc',
          }
        }
      },
      verticalAlign: 'bottom'
    }
  },
  title: {
    text: null
  },
  tooltip: {
    formatter: function() {
      return `<div class="x">${this.point.name}</div>
        <div class="c-text c-text--small">Amount of users</div>
        <div class="y" style="color: ${this.point.flatColor}">${format(this.point.value, 'number')}</div>`;
    },
    backgroundColor: '#fff',
    borderColor: '#e1e1e1',
    useHTML: true
  },
  plotOptions: {
    map: {
      mapData: Highcharts.maps['custom/world-eckert3-highres'],
      borderColor: '#fff',
      borderWidth: 0.5,
      nullColor: null,
      states: {
        hover: {
          brightness: 0,
        },
        select: {
          color: '#f9c263'
        }
      }
    },
    series: {
      animation: false,
      allAreas: false,
      allowPointSelect: true,
      point: {}
    }
  }
};

function hex2rgb(hex) {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

export default class Map {
  constructor(events = {}){
    this.config = { options: mapConfig };
    this.config.chartType = 'map';
    this.config.series = [];
    this.config.options.plotOptions.series.point.events = events;
  }

  countriesDataWithInactiveCountries(data) {
    let activeCountriesData = data.filter(item => item.players > 0);
    let activeCountriesCodes = _.map(activeCountriesData, 'country');
    let missingCountriesCodes = _.difference(worldMapKeys, activeCountriesCodes);

    return data.concat(missingCountriesCodes.map((country) => {
      return {country, players: 0};
    }))
  }

  updateCountriesData(data) {
    this.countriesData = this.countriesDataWithInactiveCountries(data);
    this.max = _.chain(this.countriesData).map('players').max().value() || 1;
  }

  getCountryData(country) {
    return _.find(this.countriesData, {country});
  }

  updateSerie(filterCountries = []) {
    let hasFilterCountires = filterCountries.length > 0;
    let blue = '#5aafef';
    let grey = '#cfcfcf';

    this.config.series = [
      {
        data: setColorScale(this.countriesData, 15).map((countryData) => {
          let hasPlayers = countryData.players > 0;
          let isFilterCountry = _.includes(filterCountries, countryData.country);
          let hexC = hasFilterCountires ? (isFilterCountry ? blue : grey) : (hasPlayers ? blue : grey);
          let rgbC = hex2rgb(hexC);
          let color = 'rgba(' + rgbC.r + ',' + rgbC.g + ',' + rgbC.b + ',' + (countryData.colorScale + 0.2).toFixed(2) + ')';

          return {
            'hc-key': String(countryData.country).toLowerCase(),
            value: countryData.players,
            flatColor: hexC,
            color: color
          };
        }),
        joinBy: 'hc-key',
        name: 'Countries'
      }
    ];
  }

  get isEmpty() {
    if (!this.config.series) {
      return false;
    } else {
      return this.config.series.filter(s => s.data.length).length == 0;
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/map/map.js
 **/